<template>
  <div id="app">
    <template v-if="hasPermission">
      <router-view></router-view>
    </template>
    <loading :loading="loading"></loading>
  </div>
</template>

<script>
import eventHub from './eventHub';
import { mapActions } from 'vuex';

const whitePathList = ['login'];

export default {
  name: 'App',
  data() {
    return {
      hasPermission: true,
      loading: false,
      message: []
    };
  },
  components: {},
  mounted() {
    document.onkeydown = function() {
      const evt = window.event || arguments[0];
      if (evt && evt.keyCode === 13 && evt.target.nodeName.includes('BUTTON')) {
        if (typeof evt.cancelBubble != 'undefined') { evt.cancelBubble = true; }
        if (typeof evt.stopPropagation == 'function') { evt.stopPropagation(); }
        return false;
      }
      return true;
    };
    eventHub.$on('authentication_failed', () => {
      if (this.$route.path !== '/login') {
        this.$myMessage({
          message: '没有访问权限',
          type: 'warn'
        });
      }
      this.$router.replace('/login');
    });
    eventHub.$on('show-loading', () => {
      this.loading = true;
    });
    eventHub.$on('hide-loading', () => {
      this.loading = false;
    });
    // 在页面刷新时将vuex里的信息保存到sessionStorage里
    window.addEventListener('beforeunload', () => {
      sessionStorage.setItem('store', JSON.stringify(this.$store.state));
    });
    if (!!window.ActiveXObject || 'ActiveXObject' in window) {
      window.addEventListener('hashchange', () => {
        const currentPath = window.location.hash.slice(1);
        if (this.$route.path !== currentPath) {
          this.$router.push(currentPath);// 主动更改路由界面
        }
      }, false);
    }
  },
  methods: {
    ...mapActions(['getUserInfo'])
  }
//   mounted() {}
};
</script>

<style>
/* html,
body,
#app {
  margin: 0;
  height: 100%;
} */

#app {
  font-family: "PingFangSC", "PingFangSC-Medium", "Arial", "Helvetica", sans-serif, "SimHei", "Microsoft YaHei";
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
  color: #2c3e50;
}

ul,
li,
a,
h1,
h2,
h3 {
  margin: 0;
  padding: 0;
}

div {
  box-sizing: border-box;
}

li {
  list-style: none;
}

a {
  text-decoration: none;
}
</style>



// WEBPACK FOOTER //
// App.vue?805e1aea